module.exports = __webpack_public_path__ + "img/mcb.da892ae1.png";